$(() => {
    const $share = $('#share');
    $share.jsSocials({
        showLabel: false,
        showCount: false,
        shares: ['telegram', 'vkontakte', 'whatsapp', 'viber', 'email'],
        shareIn: 'popup',
    });
});
